export type ViewportScaleOs = "windows" | "macos";

export const VIEWPORT_SCALE_OS_CLASS: Record<ViewportScaleOs, string> = {
  windows: "viewport-scale-os-windows",
  macos: "viewport-scale-os-macos",
};

export function detectViewportScaleOs(): ViewportScaleOs {
  if (typeof navigator === "undefined") return "windows";

  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const platformFromUaData = uaData?.platform?.toLowerCase() ?? "";
  if (platformFromUaData.includes("mac")) return "macos";
  if (platformFromUaData.includes("win")) return "windows";

  const platform = navigator.platform?.toLowerCase() ?? "";
  const ua = navigator.userAgent?.toLowerCase() ?? "";
  if (platform.includes("mac") || ua.includes("macintosh")) return "macos";
  if (platform.includes("win") || ua.includes("windows")) return "windows";

  return "windows";
}

export function applyViewportScaleOsClass(
  root: HTMLElement = document.documentElement
): ViewportScaleOs {
  const os = detectViewportScaleOs();
  root.classList.remove(VIEWPORT_SCALE_OS_CLASS.windows, VIEWPORT_SCALE_OS_CLASS.macos);
  root.classList.add(VIEWPORT_SCALE_OS_CLASS[os]);
  return os;
}
